import { useTranslation } from "react-i18next";

export interface BannerConfig {
  id: string;
  type?: 'banner' | 'blackfriday';
  title: string;
  description: string;
  secondaryText?: string;
  primaryAction: { label: string; onClick: () => void };
  secondaryAction?: { label: string; onClick: () => void };
  disabled?: boolean;
}

export const useBannerConfig = (): BannerConfig[] => {
  const { t } = useTranslation();

  return [
    {
      id: "blackfriday",
      type: 'blackfriday',
      title: "Outlet",
      description: "",
      secondaryText: "2026",
      primaryAction: {
        label: t("home.banner.outlet.cta", "Renew Your Site Now") || "Renew Your Site Now",
        onClick: () => window.location.href = '/benefits'
      }
    },
    // {
    //   id: "catalogues",
    //   title: t("home.banner.catalogues.title"),
    //   description: t("home.banner.catalogues.description"),
    //   primaryAction: { 
    //     label: t("home.banner.catalogues.cta"), 
    //     onClick: () => window.open('/catalogues', "_blank") 
    //   },
    //   secondaryAction: {
    //     label: t("home.banner.catalogues.help"),
    //     onClick: () => window.open(`${CONFIG.CONTACT_INFO.INSTAGRAM}`, "_blank")
    //   }
    // },
    // {
    //   id: "website-services",
    //   title: t("home.banner.website.title"),
    //   description: t("home.banner.website.description"),
    //   primaryAction: { 
    //     label: t("home.banner.website.pricing"),
    //     onClick: () => window.open('/benefits', "_blank")
    //   },
    // },
    // {
    //   id: "mission",
    //   title: t("home.banner.mission.title"),
    //   description: t("home.banner.mission.description"),
    //   primaryAction: { 
    //     label: t("home.banner.mission.cta"), 
    //     onClick: () => window.open('https://calendly.com/eateliers', "_blank") 
    //   }
    // },
  ];
}; 